import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import client from '../api/client';
import { getLast30DaysRange, toISODate } from '../utils/dates';
import SymptomChart from './SymptomChart';
import DietSummary from './DietSummary';
import CalendarHeatmap from './CalendarHeatmap';
import QuickStats from './QuickStats';

export default function Dashboard() {
  const [checkIns, setCheckIns] = useState([]);
  const [meals, setMeals] = useState([]);
  const [todayCheckIns, setTodayCheckIns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { start, end } = getLast30DaysRange();

    Promise.all([
      client.get('/checkins', { params: { startDate: start, endDate: end } }),
      client.get('/meals', { params: { startDate: start, endDate: end } }),
      client.get('/checkins/today'),
    ])
      .then(([checkInRes, mealRes, todayRes]) => {
        setCheckIns(checkInRes.data);
        setMeals(mealRes.data);
        setTodayCheckIns(todayRes.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white" />
      </div>
    );
  }

  const hasMorning = todayCheckIns.some(c => c.checkInType === 'MORNING');
  const hasEvening = todayCheckIns.some(c => c.checkInType === 'EVENING');
  const needsCheckIn = !hasMorning || !hasEvening;

  return (
    <div className="space-y-6">
      {/* Check-in prompt */}
      {needsCheckIn && (
        <Link
          to="/checkin"
          className="block glass !bg-white/10 text-white rounded-2xl p-6 hover:!bg-white/15 transition"
        >
          <h2 className="text-lg font-semibold">Time for your check-in</h2>
          <p className="text-white/80 mt-1">
            {!hasMorning ? 'Morning check-in is ready' : 'Evening check-in is ready'}
          </p>
        </Link>
      )}

      <QuickStats checkIns={checkIns} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SymptomChart checkIns={checkIns} />
        <DietSummary meals={meals} />
      </div>

      <CalendarHeatmap checkIns={checkIns} />
    </div>
  );
}
